import React, { useEffect, useState } from 'react';
import { Button, Modal, InputGroup} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FormGroup, Switch, Typography} from '@material-ui/core';

function CreateGuestAndCustomerModal(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const myRef = React.useRef<any>();

    const [autoCompleteOptions, setAutoCompleteOptions] = useState<Array<any>>([]);
    const [lastNameInput, setlastNameInput] = useState<Array<any>>([]);
    const [autoCompleteOptionsOrgs, setAutoCompleteOptionsOrgs] = useState<Array<any>>([]);
    const [newPersonOrganization, setNewPersonOrganization] = useState("");
    const [newPersonCompanyRegistrationId, setNewPersonCompanyRegistrationId] = useState("");

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [newPersonLastName, setNewPersonLastName] = useState("");
    const [newPersonFirstName, setNewPersonFirstName] = useState("");
    const [newPersonEmail, setNewPersonEmail] = useState("");
    const [newPersonPhone, setNewPersonPhone] = useState("");

    const [newPrivateCustomerLastName, setNewPrivateCustomerLastName] = useState("");
    const [newPrivateCustomerFirstName, setNewPrivatCustomerFirstName] = useState("");
    const [newPrivateCustomerEmail, setNewPrivateCustomerEmail] = useState("");
    const [newPrivateCustomerPhone, setNewPrivateCustomerPhone] = useState("");

    const[checkIfPrivatePerson, setCheckIfPrivatePerson] = useState(false); 

    function clearForm(){
        setNewPersonLastName("");
        setlastNameInput([{ label: "", data: ""}]);
        setNewPersonFirstName("");
        setNewPersonEmail("");
        setNewPersonPhone("");
        setNewPersonOrganization("");
        setNewPersonCompanyRegistrationId("");

        setNewPrivatCustomerFirstName("");
        setNewPrivateCustomerLastName("");
        setNewPrivateCustomerEmail("");
        setNewPrivateCustomerPhone("");
    }

    function checkFields() {
        // if(newApArNo == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_apArNo")); return undefined; }
        if (newPersonLastName == "") { notifyWarning(t("event.guests.toast_lastName_empty")); return false; }
        if (newPersonEmail !== "undefined") {
            let pattern = new RegExp(/^$|^([\w\.\-]+)@([\w\-]+)((\.(\w){2,})+)$/);
            if (!pattern.test(newPersonEmail)) {
                notifyWarning(t("people.toast_people_invalidemail"));
                return false;
            }
        }

        if (newPersonFirstName == "" ) { notifyWarning(t("event.guests.toast_firstName_empty")); return false; }
        if (newPersonEmail == "") { notifyWarning(t("event.guests.toast_email_empty")); return false; }
        if (newPersonPhone == "") { notifyWarning(t("event.guests.toast_phone_empty")); return false; }
        
        
        if (newPrivateCustomerLastName == "" && checkIfPrivatePerson) {notifyWarning(t("event.guests.toast_lastName_empty")); return false;}
        if (newPrivateCustomerFirstName == "" && checkIfPrivatePerson) {notifyWarning(t("event.guests.toast_firstName_empty")); return false;}
        if (newPrivateCustomerEmail == "" && checkIfPrivatePerson) {notifyWarning(t("event.guests.toast_email_empty")); return false;}
        if (newPrivateCustomerPhone == "" && checkIfPrivatePerson) {notifyWarning(t("event.guests.toast_phone_empty")); return false;}
        
        
        if (newPersonOrganization == ""  && !checkIfPrivatePerson ) { notifyWarning(t("event.guests.toast_organization_empty")); return false; }
        if (newPersonCompanyRegistrationId == "" && !checkIfPrivatePerson) { notifyWarning(t("event.guests.toast_companyregistrationId_empty")); return false; }
        
        return true;
    }

    function createTabbedString() {
        let guest = 
            newPersonLastName + '\t' + 
            newPersonFirstName + '\t' + 
            newPersonEmail + '\t' + 
            newPersonPhone + '\t' +                   
            newPersonOrganization + '\t' + 
            newPersonCompanyRegistrationId + '\t' +
            newPrivateCustomerPhone + '\t'+
            newPrivateCustomerLastName + '\t'+
            newPrivateCustomerFirstName + '\t'+
            newPrivateCustomerEmail + '\t';

        return guest;
    }

    function handleCreatePerson() {
        
        axios.all([
            axios.single({
                method: "get",
                url: "/api/bookings",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ]).then(axios.spread((...res) => {
        
            if(props.event.maximumHeadcount != undefined && props.event.maximumHeadcount != 0 && getEventParticipants(props.event, res[0].data) >= props.event.maximumHeadcount){
                notifyWarning(t("event.too_many_people_warning"));
            }
            
        })).catch(err => console.log(err));
        
        if (checkFields()) {
            axios.post("/api/events/addsGuestsInfo",
                {
                    data: createTabbedString(),
                    event: props.event
                },
                {
                    headers: {'x-access-token': auth.user["token"]}
                }
            ).then(res => {
                if (props.onSaveNew != undefined) props.onSaveNew(res.data.createdGuestList);
                if (props.onBookingsChange != undefined) props.onBookingsChange(res.data.changedBookings);
                if (props.onCustomersChange != undefined) props.onCustomersChange([res.data.createdCustomer]);

                if(res.data.duplicate == true){ 
                    notifySuccess(t("people.toast_people_duplicate"))}
                else{
                    notifySuccess(t("people.toast_people_created"));  
                }
                
                clearForm();
            });
        }
    }

    const newPersonNameChange = (value) => {
        if (value.length > 1) {
            axios.post('/api/persons/search',
                {
                    filter: value
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                }
            ).then(function (response) {
                setAutoCompleteOptions(response.data.map(item => { return { id: item._id, label: item.lastname, data: item }}));
                //setlastNameInput(autoCompleteOptions.length > 0 ? [...autoCompleteOptions] : [{label: value, data: value}])
            });
        }
        setlastNameInput([{label: value, data: value}])
        setNewPersonLastName(value);
    };

    const newPrivateCustomerPhoneChange = (value) => {
        if (value.length > 1) {
            axios.post('/api/customers/search/phonenumber',
                {
                    filter: value
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                }
            ).then(function (response) {
                setAutoCompleteOptions(response.data.map(item => { return { id: item._id, label: item.phone, data: item }}));
            });
        }
        setNewPrivateCustomerPhone(value);
    };

    const newPersonOrganizationChange = (value) => {
        setNewPersonOrganization(value);
    };

    const newPersonOrganizationSelected = (value) => {
        setNewPersonCompanyRegistrationId(value.data.companyRegistrationId);
        setNewPersonOrganization(value.label);
    };
    
    function getEventParticipants(event, allBookings) {
        let participants = 0;
        allBookings.forEach(booking => {
            if(booking["events"] != undefined && booking["events"].map(event => event._id).includes(event._id)){
                participants += booking["guests"].length;
            }
        });
        return participants;
    }
    
    useEffect(() => {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/customers",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            })
        ]).then(axios.spread((...res) => {
            let orgOptionsList: Array<any> = [];
            let autoCompleteOptionsList: Array<any> = [];
            let customersOrgOptions = res[0].data;
            customersOrgOptions.forEach((customer) => {
                if(!orgOptionsList.map(i => i.organizationName).includes(customer.organizationName)){
                    orgOptionsList.push(customer);
                    autoCompleteOptionsList.push({ id: customer._id, label: customer.organizationName, data: customer });
                } 
            });
            setAutoCompleteOptionsOrgs(autoCompleteOptionsList.filter(i => i.label != undefined && i.label != null && i.label != ""));
        })).catch(err => console.log(err));
    }, []);

    return (
        <Modal show={props.show} onHide={() =>  {
            if(props.onHide != undefined) props.onHide();
            setNewPersonLastName("");
            setNewPersonFirstName("");
            setNewPersonEmail("");
            setNewPersonPhone("");
            setNewPersonOrganization("");
            setNewPersonCompanyRegistrationId("")
            
        }}> 
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("people.new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <FormGroup>
                <div className="row">
                <Typography className="ml-1 mb-3">{(t("customers.customerSwitch"))}</Typography> 
                <Switch 
                    onChange={() => checkIfPrivatePerson == false ? setCheckIfPrivatePerson(true) : setCheckIfPrivatePerson(false)}
                    checked={checkIfPrivatePerson} className="ml-2 "
                    inputProps={{ 'aria-label': 'ant design' }}
                />
                <Typography className="ml-1 mb-3">{(t("customers.privePersonSwitch"))}</Typography>
                </div>
            </FormGroup>
            {checkIfPrivatePerson == false ? <div>
                {props.onSelectExisting != undefined ?
                    <InputGroup className="mb-3">
                        <InputGroup.Prepend>
                            <InputGroup.Text>{t("people.lastname") + '*'}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Typeahead
                            id="newPersonLastNameInput"
                            onInputChange={newPersonNameChange}
                            className="typeaheadinput"
                            onChange={items => {
                                //if you choose autofill
                                if (items.length > 0) {
                                    if (items[0]["id"] != undefined && items[0]["id"] != "") {
                                        let selectedOption = (props.people.find(item => item["_id"] == items[0]["id"]) as any);

                                        setNewPersonLastName(selectedOption.lastname);
                                        setNewPersonFirstName(selectedOption.firstname);
                                        setNewPersonEmail(selectedOption.email);
                                        setNewPersonPhone(selectedOption.phone);
                                    } 
                                    newPersonNameChange(items[0]["label"])
                                } 
                            }}
                            //override default 
                            renderMenuItemChildren={(option, props, index) => {
                                return(
                                    <div>
                                        <p style={{lineHeight: "16px", marginBottom: "0px"}}>
                                            <span style={{ fontSize: "11px" }}>{option.data.organization}</span><br/>
                                            <span style={{ fontSize: "12px" }}>{option.data.email} | {option.data.phone}</span><br/>
                                            <span>{option.data.lastname}, {option.data.firstname}</span>
                                        </p>
                                        <hr/>
                                    </div>
                                );
                            }}
                            ref={myRef}
                            minLength={2}
                            emptyLabel={t("person.no_results")}
                            options={autoCompleteOptions} 
                            selected={lastNameInput}
                        />
                    </InputGroup>
                :
                    <Field
                        type="input"
                        title={t("people.lastname") + '*'}
                        value={newPersonLastName}
                        onChange={value => setNewPersonLastName(value)}
                    ></Field>
                }
                 <Field
                    type="input"
                    title={t("people.firstname") + '*'}
                    value={newPersonFirstName}
                    onChange={value => setNewPersonFirstName(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("people.email") + '*'}
                    value={newPersonEmail}
                    onChange={value => setNewPersonEmail(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("people.phone") + '*'}
                    value={newPersonPhone}
                    onChange={value => setNewPersonPhone(value)}
                ></Field>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>{t("people.organization") + '*'}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Typeahead
                        id="newPersonOrganizationInput"
                        onInputChange={newPersonOrganizationChange}
                        className="typeaheadinput"
                        onChange={items => {
                            if (items.length > 0) {
                                newPersonOrganizationSelected(items[0])
                            } else return null;
                        }}
                        emptyLabel={t("person.no_results")}
                        options={autoCompleteOptionsOrgs}
                    />
                </InputGroup>
                <Field
                    type="input"
                    title={t("customer.companyRegistrationId") + '*'}
                    value={newPersonCompanyRegistrationId}
                    onChange={value => setNewPersonCompanyRegistrationId(value)}
                ></Field>
               
            </div>
        : 
 //--------------------PRIVATE CUSTOMER----------------------------------------------------------------------------------------------------------------------------           
            <div>               
            <p>{(t("people.privateCusromerInfo"))}</p>

            {/* <Field
                type="input"
                title={t("people.phone") + '*'}
                value={newPersonPhone}
                onChange={value => setNewPersonPhone(value)}
            ></Field> */}
            {props.onSelectExisting != undefined ?
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>{t("customers.phone") + '*'}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Typeahead
                        id="newPrivateCustomerPhone"
                        onInputChange={newPrivateCustomerPhoneChange}
                        className="typeaheadinput"
                        onChange={items => {
                            //if you choose autofill
                            if (items.length > 0) {
                                if (items[0]["id"] != undefined && items[0]["id"] != "") {
                                    let selectedOption = (props.customers.find(item => item["_id"] == items[0]["id"]) as any);

                                    setNewPrivateCustomerLastName(selectedOption.lastname);
                                    setNewPrivatCustomerFirstName(selectedOption.firstname);
                                    setNewPrivateCustomerEmail(selectedOption.email);
                                    setNewPrivateCustomerPhone(selectedOption.phone);
                                } 
                                newPrivateCustomerPhoneChange(items[0]["label"])
                            } 
                        }}
                        //override default 
                        renderMenuItemChildren={(option, props, index) => {
                            return(
                                <div>
                                    <p style={{lineHeight: "16px", marginBottom: "0px"}}>
                                        <span style={{ fontSize: "11px" }}>{option.data.organization}</span><br/>
                                        <span style={{ fontSize: "12px" }}>{option.data.email} | {option.data.phone}</span><br/>
                                        <span>{option.data.lastname}, {option.data.firstname}</span>
                                    </p>
                                    <hr/>
                                </div>
                            );
                        }}
                        ref={myRef}
                        minLength={2}
                        emptyLabel={t("customers.no_results")}
                        options={autoCompleteOptions} 
                    />
                </InputGroup>
            :
                <Field
                    type="input"
                    title={t("customers.phone") + '*'}
                    value={newPrivateCustomerPhone}
                    onChange={value => newPrivateCustomerPhoneChange(value)}
                ></Field>
            }
            <Field
                type="input"
                title={t("customers.lastname") + '*'}
                value={newPrivateCustomerLastName}
                onChange={value => setNewPrivateCustomerLastName(value)}
            ></Field>
            <Field
                type="input"
                title={t("customers.firstname") + '*'}
                value={newPrivateCustomerFirstName}
                onChange={value => setNewPrivatCustomerFirstName(value)}
            ></Field>
            <Field
                type="input"
                title={t("customers.email") + '*'}
                value={newPrivateCustomerEmail}
                onChange={value => setNewPrivateCustomerEmail(value)}
            ></Field>

   {/* ------------------------ Private Guesst-----------------------------------------------------------------------*/}
        <hr />
            <p>{(t("people.privateGuestInfo"))}</p>
                 {props.onSelectExisting != undefined ?
                    <InputGroup className="mb-3">
                        <InputGroup.Prepend>
                            <InputGroup.Text>{t("people.lastname") + '*'}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Typeahead
                            id="newPersonLastNameInput"
                            onInputChange={newPersonNameChange}
                            className="typeaheadinput"
                            onChange={items => {
                                //if you choose autofill
                                if (items.length > 0) {
                                    if (items[0]["id"] != undefined && items[0]["id"] != "") {
                                        let selectedOption = (props.people.find(item => item["_id"] == items[0]["id"]) as any);

                                        setNewPersonLastName(selectedOption.lastname);
                                        setNewPersonFirstName(selectedOption.firstname);
                                        setNewPersonEmail(selectedOption.email);
                                        setNewPersonPhone(selectedOption.phone);
                                    } 
                                    newPersonNameChange(items[0]["label"])
                                } 
                            }}
                            //override default 
                            renderMenuItemChildren={(option, props, index) => {
                                return(
                                    <div>
                                        <p style={{lineHeight: "16px", marginBottom: "0px"}}>
                                            <span style={{ fontSize: "11px" }}>{option.data.organization}</span><br/>
                                            <span style={{ fontSize: "12px" }}>{option.data.email} | {option.data.phone}</span><br/>
                                            <span>{option.data.lastname}, {option.data.firstname}</span>
                                        </p>
                                        <hr/>
                                    </div>
                                );
                            }}
                            ref={myRef}
                            minLength={2}
                            emptyLabel={t("person.no_results")}
                            options={autoCompleteOptions} 
                            selected={lastNameInput}
                        />
                    </InputGroup>
                :
                    <Field
                        type="input"
                        title={t("people.lastname") + '*'}
                        value={newPersonLastName}
                        onChange={value => setNewPersonLastName(value)}
                    ></Field>
                }
                 <Field
                    type="input"
                    title={t("people.firstname") + '*'}
                    value={newPersonFirstName}
                    onChange={value => setNewPersonFirstName(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("people.email") + '*'}
                    value={newPersonEmail}
                    onChange={value => setNewPersonEmail(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("people.phone") + '*'}
                    value={newPersonPhone}
                    onChange={value => setNewPersonPhone(value)}
                ></Field>

            </div>}
                
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { if(props.onCancel != undefined) props.onCancel(); clearForm();}}>
                    {t("people.cancel")}
                </Button>
                <Button onClick={() => {
                    handleCreatePerson()
                }}>
                    {t("people.save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreateGuestAndCustomerModal;